import { cloneDeep } from "lodash";
import { NumberFilterOptions, PredefinedFilters } from "components/config/grid-templates/predefined-filters";
export const getFormattedValueQuickFilterText = (params) => {
    if (params.column.isVisible() && params.value) {
        if (params.colDef.valueFormatter && typeof params.colDef.valueFormatter !== "string") {
            return params.colDef.valueFormatter({
                api: params.api,
                colDef: params.colDef,
                column: params.column,
                context: params.context,
                data: params.data,
                node: params.node,
                value: params.value
            });
        }
        return params.value;
    }
    return "";
};
export const getCommonQuickFilterText = (params) => {
    if (params.column.isVisible() || (params.column.isRowGroupActive && params.column.isRowGroupActive())) {
        return params.value;
    }
    return "";
};
export const getUpdatedFilterModelColumnsFromConfig = (filterModel, asOfDate) => {
    if (!filterModel || !filterModel.columns) {
        return null;
    }
    const newFilterModelColumns = cloneDeep(filterModel.columns);
    Object.keys(newFilterModelColumns).forEach((key) => {
        const columnFilter = newFilterModelColumns[key];
        if (columnFilter.predefinedFilter || columnFilter.predefinedFilter === 0) {
            const actualColumnFilter = PredefinedFilters[columnFilter.predefinedFilter](asOfDate);
            newFilterModelColumns[key] = { ...actualColumnFilter };
        }
    });
    return newFilterModelColumns;
};
export const getUpdatedFilterModelForTopFilter = (filterModel, colId) => {
    const colFilter = filterModel[colId];
    if (!colFilter) {
        return filterModel;
    }
    if (colFilter && [colFilter.type, colFilter.condition2?.type].some((option) => option === NumberFilterOptions.top || option === NumberFilterOptions.bottom)) {
        const { filter, filterType, type } = colFilter;
        const { filter: condition2Filter, filterType: condition2FilterType, type: condition2Type } = colFilter.condition2 || {};
        return {
            [colId]: {
                filter: filter || condition2Filter,
                filterType: filterType || condition2FilterType,
                type: type || condition2Type
            }
        };
    }
    if (colFilter.filterModels?.[0] && (colFilter.filterModels[0].type === NumberFilterOptions.top || colFilter.filterModels[0].type === NumberFilterOptions.bottom)) {
        return { [colId]: { ...colFilter } };
    }
    return filterModel;
};
